import React from 'react'
import AddToListIconSVG from "../../../assets/icons/add-to-list-icon.svg"
export const AddToListIcon: React.FC = () => {
  return (
    <img src={AddToListIconSVG} alt="" className="w-[50] h-[50] cursor-pointer" />
  )
}
